export default function WeatherReportEvidenceSection({ evidence }) {
  if (!evidence) {
    return null;
  }

  const gauges = evidence.rainGauges || [];
  const quebradas = evidence.quebradaLevels || [];
  const alerts = evidence.alerts || [];

  return (
    <section className="panel-card weather-report-evidence">
      <p className="eyebrow">Nearby signals</p>
      <div className="weather-report-evidence__grid">
        <div>
          <h4>Rain gauges</h4>
          {gauges.length ? (
            <ul>
              {gauges.slice(0, 3).map((row) => (
                <li key={row.stationId || row.name}>
                  {row.name || row.stationId}: {row.valueNumeric ?? "—"} {row.unit || ""}
                  {row.distanceM != null ? ` (${Math.round(row.distanceM)} m)` : ""}
                </li>
              ))}
            </ul>
          ) : (
            <p className="muted">No rain gauges in range.</p>
          )}
        </div>
        <div>
          <h4>Stream / quebrada sensors</h4>
          {quebradas.length ? (
            <ul>
              {quebradas.slice(0, 3).map((row) => (
                <li key={row.stationId || row.name}>
                  {row.name || row.stationId}: {row.status || "—"}
                  {row.distanceM != null ? ` (${Math.round(row.distanceM)} m)` : ""}
                </li>
              ))}
            </ul>
          ) : (
            <p className="muted">No quebrada sensors in range.</p>
          )}
        </div>
        <div>
          <h4>Active alerts</h4>
          {alerts.length ? (
            <ul>
              {alerts.slice(0, 5).map((row) => (
                <li key={row.id || row.title}>{row.title || row.alertType || "Alert"}</li>
              ))}
            </ul>
          ) : (
            <p className="muted">No active alerts in range.</p>
          )}
        </div>
      </div>
    </section>
  );
}
